import { FILTER_LOCATION_SELECTOR_TYPES } from "./FilterLocationLinks";

export default [
  {
    name: "tags",
    label: "Tags",
    icon: "tag",
    row: {
      conjunctions: [
        { name: "or", label: "or" },
        { name: "and", label: "and" }
      ],
      selector_prefix: [
        { name: "is_tagged", label: "is tagged" },
        { name: "is_not_tagged", label: "is not tagged" }
      ],
      selectors: [],
      data_settings: {
        searchable: true,
        default_label: "any tag",
        searchable_dropdown_placeholder: "Search tag name",
        not_found_message: 'No tags found.',
        no_options_message: 'No tags available.',
        exclusion_selector: "is_not_tagged",
        exclusion_type: "selector"
      },
      data: [{ name: "any tag" }]
    }
  },
  {
    name: "campaign_activity",
    label: "Campaign activity",
    icon: "zap",
    row: {
      conjunctions: [
        { name: "or", label: "or" },
        { name: "and", label: "and" }
      ],
      selector_prefix: [{ name: "has" }, { name: "has not" }],
      selectors: [
        { name: "joined", label: "joined" },
        {
          name: "contacted",
          label: "contacted",
          sub_selectors: [
            { name: "contacted", label: "contacted (any type)" },
            { name: "emailed", label: "emailed" },
            { name: "tweeted", label: "tweeted" },
            { name: "called", label: "called" }
          ]
        },
        { name: "signed_a_petition", label: "signed a petition" },
        { name: "signed_up", label: "signed up" }
      ],
      selector_suffix: [
        { name: "at any time", label: "at any time" },
        { name: "today", label: "today"},
        { name: "yesterday", label: "yesterday"},
        { name: "this month", label: "this month"},
        { name: "last month", label: "last month"},
        { name: "last 7 days", label: "last 7 days"},
        { name: "last 30 days", label: "last 30 days"},
        { name: "last 90 days", label: "last 90 days"},
        { name: "this year", label: "this year"},
        { name: "last year", label: "last year"},
        { name: "before", label: "before", start: new Date()},
        { name: "after", label: "after", start: new Date()},
        { name: "on", label: "on", start: new Date()},
        { name: "custom date range", label: "custom date range", start: new Date(), end: new Date()}
      ],
      data_settings: {
        prefix: "on: ",
        searchable: true,
        default_label: "any campaign",
        searchable_dropdown_placeholder: "Search campaign name or ID",
        not_found_message: 'No campaigns found.',
        no_options_message: 'No campaigns available.',
        show_id: true,
        exclusion_selector: "has not",
        exclusion_type: "selector_prefix",
        extended_selection_prefix_label: "any official",
        extended_selection_prefix_placeholder: "Enter 3 or more characters...",
        extended_selection_prefix_options: [],
        suffix_not_found_message: 'Searching...',
        wider_dropdown: true,
      },
      data: [{ name: "any campaign" }]
    }
  },
  {
    name: "location",
    label: "Location",
    icon: "map-pin",
    row: {
      conjunctions: [
        { name: "or", label: "or" },
        { name: "and", label: "and" }
      ],
      selector_prefix: [
        { name: "lives_in", label: "lives in" },
        { name: "does_not_live_in", label: "does not live in" }
      ],
      selectors: [
        { name: "Any location", selected_label: "any location" },
        { name: "State", selected_label: "the state of", data: [{ name: "any state" }], selectorType: FILTER_LOCATION_SELECTOR_TYPES.STATE, default_label: "any state", async_search: false },
        { name: "City", selected_label: "the city of", data: [{ name: "any city" }], selectorType: FILTER_LOCATION_SELECTOR_TYPES.CITY, default_label: "any city", async_search: true},
        { name: "County", selected_label: "the county of", data: [{ name: "any county" }], selectorType: FILTER_LOCATION_SELECTOR_TYPES.COUNTY, default_label: "any county", async_search: true },
        { name: "Zip Code", selected_label: "the zip code of", data: [{ name: "any zip code" }], selectorType: FILTER_LOCATION_SELECTOR_TYPES.ZIP, default_label: "any zip code", async_search: true },
        { name: "Country", selected_label: "the country of", data: [{ name: "any country" }], selectorType: FILTER_LOCATION_SELECTOR_TYPES.COUNTRY, default_label: "any country", async_search: true },
        { name: "Legislative District", selected_label: "the legislative district of", data: [{name: 'any chamber'}], selectorType: FILTER_LOCATION_SELECTOR_TYPES.DISTRICT, async_search: false, searchable: false, use_extended_selection_data: true},
        { name: "Committee District", selected_label: "a district of a legislator", data: [{name: 'any chamber'}], selectorType: FILTER_LOCATION_SELECTOR_TYPES.COMMITTEE, async_search: false, searchable: false, use_extended_selection_data: true, use_extended_selection_suffix_data: true},
      ],
      data: [{ name: "any chamber" }],
      data_settings: {
        searchable: true,
        default_label: "any chamber",
        searchable_dropdown_placeholder: "Enter 3 or more characters...",
        not_found_message: null,
        no_options_message: 'Searching...',
        show_id: false,
        showDataCondition: "any location",
        searchable_dropdown_row: false,
        reset_label: "any chamber",
        extended_selection_data_label: "any district",
        extended_selection_suffix_data_label: "any sub committee",
        exclusion_type: "selector_prefix",
        exclusion_selector: "does_not_live_in"
      }
    }
  },
  {
    name: "created_on",
    label: "Created on",
    icon: "calendar",
    row: {
      conjunctions: [{ name: "or", label: "or" }],
      selector_prefix: [{ name: "created", label: "was created on"}],
      data_settings: {},
      selectors: [],
      data: [],
      selector_suffix: [
        { name: "at any time", label: "at any time" },
        { name: "today", label: "today"},
        { name: "yesterday", label: "yesterday"},
        { name: "this month", label: "this month"},
        { name: "last month", label: "last month"},
        { name: "last 7 days", label: "last 7 days"},
        { name: "last 30 days", label: "last 30 days"},
        { name: "last 90 days", label: "last 90 days"},
        { name: "this year", label: "this year"},
        { name: "last year", label: "last year"},
        { name: "before", label: "before", start: new Date()},
        { name: "after", label: "after", start: new Date()},
        { name: "on", label: "on", start: new Date()},
        { name: "custom date range", label: "custom date range", start: new Date(), end: new Date() }
      ]
    },
  },

  {
    name: "join_date",
    label: "Join date",
    icon: "calendar",
    row: {
      conjunctions: [{ name: "or", label: "or" }],
      selector_prefix: [{ name: "joined"}],
      data_settings: {},
      selectors: [],
      data: [],
      selector_suffix: [
        { name: "at any time", label: "at any time" },
        { name: "custom date range", label: "custom date range", start: new Date(), end: new Date() }
      ]
    },
  },
  {
    name: "optin",
    label: "Opted-in",
    icon: "check-circle",
    row: {
      conjunctions: [
        { name: "or", label: "or" },
        { name: "and", label: "and" }
      ],
      selector_prefix: [{ name: "is" }, { name: "is not" }],
      data: [],
      data_settings: {
        exclusion_type: "selector_prefix"
      },
      selectors: [],
      selector_suffix: [
        { name: "opted in", label: "Opted in" },
        { name: "opted in to text messages", label: "Opted in to text messages" },
        { name: "opted in to email", label: "Opted in to email" },
      ]
    }
  },
  {
    name: "email_activity",
    label: "Email activity",
    icon: "mail",
    row: {
      conjunctions: [
        { name: "or", label: "or" },
        { name: "and", label: "and" }
      ],
      selector_prefix: [{ name: "has" }, { name: "has not" }],
      selectors: [
        { name: "received", label: "been delivered" },
        { name: "opened", label: "opened" },
        { name: "clicked", label: "clicked on" },
        { name: "converted", label: "converted from" },
        { name: "emailed", label: "emailed from" },
        { name: "tweeted", label: "tweeted from" },
        { name: "called", label: "called from" },
        { name: "bounced", label: "been bounced from" },
        { name: "blocked", label: "been blocked from" },
        { name: "dropped", label: "been dropped from" },
        { name: "deferred", label: "been deferred from" },
        { name: "unsubscribed", label: "unsubscribed from" },
        { name: "marked as spam", label: "marked as spam" },
      ],
      selector_suffix: [
        { name: "at any time", label: "at any time" },
        { name: "today", label: "today"},
        { name: "yesterday", label: "yesterday"},
        { name: "this month", label: "this month"},
        { name: "last month", label: "last month"},
        { name: "last 7 days", label: "last 7 days"},
        { name: "last 30 days", label: "last 30 days"},
        { name: "last 90 days", label: "last 90 days"},
        { name: "this year", label: "this year"},
        { name: "last year", label: "last year"},
        { name: "before", label: "before", start: new Date()},
        { name: "after", label: "after", start: new Date()},
        { name: "on", label: "on", start: new Date()},
        { name: "custom date range", label: "custom date range", start: new Date(), end: new Date()}
      ],
      data_settings: {
        searchable: true,
        default_label: "any email",
        searchable_dropdown_placeholder: "Search email name or ID",
        not_found_message: 'No email found.',
        no_options_message: 'No email available.',
        show_id: true,
        exclusion_selector: "has not",
        exclusion_type: "selector_prefix",
      },
      data: [{ name: "any email" }]
    }
  },
  {
    name: "stages",
    label: "Advocate stage",
    icon: "bar-chart",
    row: {
      conjunctions: [
        { name: "or", label: "or" },
        { name: "and", label: "and" }
      ],
      selector_prefix: [
        { name: "is_stage", label: "is a" },
        { name: "is_not_stage", label: "is not a" }
      ],
      selectors: [],
      data_settings: {
        searchable: true,
        default_label: "any stage",
        searchable_dropdown_placeholder: "Search advocate stage",
        not_found_message: 'No stages found.',
        no_options_message: 'No stages available.',
        exclusion_selector: "is_not_stage",
        exclusion_type: "selector"
      },
      data: [{ name: "any stage" }]
    }
  },
  {
    name: "sources",
    label: "Advocate source",
    icon: "user",
    row: {
      conjunctions: [
        { name: "or", label: "or" },
        { name: "and", label: "and" }
      ],
      selector_prefix: [
        { name: "is_from_source", label: "is from" },
        { name: "is_not_from_source", label: "is not from" }
      ],
      selectors: [],
      data_settings: {
        searchable: true,
        default_label: "any source",
        searchable_dropdown_placeholder: "Search source name",
        not_found_message: 'No sources found.',
        no_options_message: 'No sources available.',
        exclusion_selector: "is_not_source",
        exclusion_type: "selector"
      },
      data: [{ name: "any source" }]
    }
  },
]
